import { Component, OnInit } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';

@Component({
    selector: 'vit-jackpot-bubble',
    templateUrl: './jackpot-bubble.component.html',
    styleUrls: ['./jackpot-bubble.component.scss']
})
export class JackpotBubbleComponent implements OnInit {

    constructor(public sessionService: SessionService) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/jackpot-bubble/jackpot-bubble.component.ts